import Validators from "../../services/validators";
const LIMITS = { ...Validators,
  loginLength: 5,
  passwordLength: 8
};
export default {
  methods: {
    validateLogin(login) {
      return new Promise((success, reject) => {
        if (login.length < LIMITS.loginLength) {
          return reject({
            message: this.$tc('form.register.validation.login.short', LIMITS.loginLength)
          });
        }

        if (!LIMITS.loginRegex.test(login)) {
          return reject({
            message: this.$t(`form.register.validation.login.wrong_symbols "${login.replace(LIMITS.loginRegex, '')}"`)
          });
        }

        this.networkCheckLogin(login).then(response => {
          switch (response.status) {
            case "ok":
              success();

            case 1:
              reject({
                message: this.$t('form.register.validation.login.exists')
              });
          }
        });
      });
    },

    validateEmail(email) {
      return new Promise((success, reject) => {
        if (!LIMITS.emailRegex.test(email)) {
          return reject({
            message: this.$t('form.register.validation.email.wrong')
          });
        }

        this.networkCheckEmail(email).then(response => {
          switch (response.status) {
            case "ok":
              success();

            case 1:
              reject({
                message: this.$t('form.register.validation.email.exists')
              });
          }
        });
      });
    },

    validatePassword(password) {
      return new Promise((success, reject) => {
        if (!LIMITS.passwordRegex.test(password)) {
          return reject({
            message: this.$t('form.register.validation.password.wrong')
          });
        }

        success();
      });
    },

    validateRepeatPassword(password) {
      return new Promise((success, reject) => {
        if (password != this.form.password) {
          return reject({
            message: this.$t('form.register.validation.password_repeat.not_equal')
          });
        }

        success();
      });
    },

    isFormValid() {
      return Object.keys(this.$refs).every(key => !key.startsWith("form.") || this.$refs[key].isValid());
    }

  }
};